export default __webpack_public_path__ + "static/media/enragingstrike1.2ee566cd.png";